import { render, staticRenderFns } from "./PesertaPib.vue?vue&type=template&id=09de84bc"
import script from "./PesertaPib.vue?vue&type=script&lang=js"
export * from "./PesertaPib.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports